import axios from 'axios'
import store from '../store';

export default {
    // Listado con filtros (igual que vehicles.get)
    get: (filters) => axios.post('properties', filters),
    show: (data) => axios.post('properties/show', data),
    deleteImage: (data) => axios.post('properties/delete-image', data),

    // Si en algún momento quieres clasificar propiedades por categoría
    // (ej. tipo, situación, etc.), puedes reutilizar esta firma
    getByCategory: (category) => axios.post('properties', { category: category }),

    // Crear nueva propiedad
    store: (data) => axios.post('properties/store', data, data instanceof FormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : undefined),

    // Importar propiedades desde archivo (Excel/CSV)
    import: (data) => axios.post('properties/import', data),

    // Actualizar propiedad
    update: (data) => axios.post('properties/update', data, data instanceof FormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : undefined),

    // Activar propiedad
    active: (id) => axios.post('properties/active', id),

    // Desactivar propiedad
    deactive: (id) => axios.post('properties/deactive', id),

    // Enviar a papelera / eliminar lógico
    delete: (id) => axios.post('properties/delete', id),

    // Crear nueva propiedad
    assign: (data) => axios.post('properties/assign', data),
    storeDocument: (data) => axios.post('properties/documents/store', data, { headers: { 'Content-Type': 'multipart/form-data' } }),
    deleteDocument: (data) => axios.post('properties/documents/delete', data),

    // Descargar Excel de inventario de propiedades
    downloadExcel: (filters) => axios.post('properties/download-excel', filters).then(function (response) {
        if (response.type == "success") {
            window.open(response.data, '_blank');
        } else {
            store.commit('toast', { color: response.type, message: response.message });
        }
    }),

    // Descargar ficha PDF de propiedad
    downloadRecord: (data) => axios.post('properties/download-record', data).then(function (response) {
        if (response.type == "success") {
            window.open(response.data, '_blank');
        } else {
            store.commit('toast', { color: response.type, message: response.message });
        }
    }),

    // Descargar ficha institucional de propiedad
    downloadSheet: (data) => axios.post('properties/download-sheet', data).then(function (response) {
        if (response.type == "success") {
            window.open(response.data, '_blank');
        } else {
            store.commit('toast', { color: response.type, message: response.message });
        }
    }),

    downloadProfileSheet: (data) => axios.post('properties/download-profile-sheet', data).then(function (response) {
        if (response.type == "success") {
            window.open(response.data, '_blank');
        } else {
            store.commit('toast', { color: response.type, message: response.message });
        }
    }),

    // 🔹 NOTA:
    // En el módulo de propiedades (por ahora) no te puse equivalentes a:
    // - vehicles/qr-store, qr-update
    // - vehicles/init-tags, download-tags, download-tags-mini
    //
    // Si más adelante quieres QR o etiquetas físicas para propiedades,
    // se pueden agregar métodos análogos aquí, por ejemplo:
    //
    // storeQR: (data) => axios.post('properties/qr-store', data),
    // updateQR: (data) => axios.post('properties/qr-update', data),
    // initTags: (quantity) => axios.post('properties/init-tags', { quantity }).then(...),
    // downloadTags: (filters) => axios.post('properties/download-tags', filters).then(...),
    // etc.
}
